const SI_SYMBOLS = ['', 'тыс', 'млн', 'млрд', 'трлн'];
const RUB_SYMBOL = 'р.';

const amountCountFormatter = amount => {
  // eslint-disable-next-line no-bitwise
  const tier = (Math.log10(amount) / 3) | 0;

  if (tier === 0) {
    return `${amount} ${RUB_SYMBOL}`;
  }

  const suffix = SI_SYMBOLS[tier];
  const scale = 10 ** (tier * 3);

  const scaled = parseInt(amount / scale, 10);

  const resultStr = `${scaled} ${suffix} ${RUB_SYMBOL}`;

  return resultStr;
};

export default amountCountFormatter;
